<script>
  import { Link, navigate } from "svelte-routing";
  import { _ } from 'svelte-i18n';

  import ChangeFontSize from "./ChangeFontSize.svelte";

  import { api } from "./../libs/api.js";
  import { i18n } from './../libs/lang.js';

  export let current_course;

  function handle_logout(ev) {
    api.logout();
    navigate('/');
  }

  function setLanguage(lang_id) {
    let prev_code = i18n.language;

    if (lang_id != prev_code) {
      i18n.language = lang_id;
      location.reload()
    }

    return "";
  }
</script>

<div>

  <div class="drawer drawer-mobile">
    <input id="my-drawer-2" type="checkbox" class="drawer-toggle" />
    <div class="drawer-content flex flex-col overflow-hidden">
      <label for="my-drawer-2" class="btn btn-primary drawer-button lg:hidden">Open Mobile Menu</label>
    
      <slot>
        <div class="hero min-h-screen bg-base-100">
          <div class="hero-content flex">
            <p> {$_('base.loading')} </p>
          </div>
        </div>
      </slot>
    
    </div> 
    <div class="drawer-side">
      <label for="my-drawer-2" class="drawer-overlay"></label>
      <div class="menu py-4 w-80 bg-base-200 text-base-content justify-between">

        <Link to="/start">
          <img class="w-2/3 mx-auto" src="/assets/logo.png" />
        </Link>
        
        <ul>
          {#await api.get_courses() then courses}
            {#each courses.data as el}
              <li class="mt-2 bg-base-300 text-white {el.id == current_course ? 'bg-primary text-primary-content' : ''}">
                <Link class="w-full justify-center uppercase text-center" to="course/{el.id}">{el.name}</Link>
              </li>
            {/each}
          {/await}
        </ul>

      <label class="swap">
        <input type="checkbox" />

        <div class="swap-off" on:click="{handle_logout}">
          <img class="w-16 mx-auto" src="/assets/user_circle.svg" />
          <p class="text-center font-bold">
          {#await api.get_user_self() then user}
            {setLanguage(user.data[0].affiliation.language)}
            {user.data[0].first_name} {user.data[0].last_name}
          {/await}
          </p>
        </div>

        <div class="swap-on">
          <div class="w-24 mx-auto cursor-pointer text-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-12 h-12 mx-auto my-2 fill-error"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"/></svg>
            <span class="block font-bold uppercase"> {$_('base.logout')} </span>
          </div>
        </div>
      </label>

      <ChangeFontSize />

      </div>
    
    </div>
  </div>

</div>